// extracted by mini-css-extract-plugin
module.exports = {"arrowHeight":"6px","arrowBottomSideLength":"10px"};
    if(module.hot) {
      // 1764725643630
      var cssReload = require("D:/GitWorkplace/物联网/tenda_iot_system/node_modules/_mini-css-extract-plugin@0.9.0@mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  